import React from 'react'
import { observable, action } from 'mobx'
import { observer } from 'mobx-react'
import PriceManagerContext from './contexts/PriceManagerContext'

class PriceManager extends React.Component {

  constructor (props) {
    super(props)
    this.updatePrice()
  }

  _price = observable.box({
    ports: {
      0: {
        price: ',-',
        price_vat: ',-',
      }
    },
    totals: {
      price: ',-',
      price_vat: ',-',
    }
  })

  get price () {
    return this._price.get()
  }

  _is_updating = observable.box(false)

  get is_updating () {
    return this._is_updating.get()
  }

  @action
  set is_updating (bool) {
    if (typeof bool !== 'boolean') return
    return this._is_updating.set(bool)
  }

  getPortPrice (port_id) {
    if (!this.price.ports.hasOwnProperty(port_id)) return { price: 0, price_vat: 0 }
    return this.price.ports[port_id]
  }

  getTotalPrice () {
    return this.price.totals
  }

  updatePrice () {
    this.is_updating = true
    let that = this
    this.props.operation.getPrice(that.priceCallback.bind(that))
  }

  @action
  priceCallback (res, status, xhr) {
    if (status === 'success') {
      this.is_updating = false
      if (typeof res.prices !== 'object') return
      this._price.set(res.prices)
    }
  }

  render () {
    return (
      <PriceManagerContext.Provider value={this}>
        <React.Fragment>
          {this.props.children}
        </React.Fragment>
      </PriceManagerContext.Provider>
    )
  }
}

export default observer(PriceManager)